/* template */
<template><div class="loading"><spinner class="loading-spinner"/></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"md8a157b0"}'>
.loading
  width 100%
  height 200rpx
  display flex
  flex-flow row nowrap
  justify-content center
  align-items center
.loading-spinner
  flex none
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'

createComponent({
  name: 'Loading',
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "loadingd8a157b0",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'spinner':getComponent(require("../../../common/spinner.mpx?component=true&componentId=spinner7c48ff6a"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
